import { DataGranularity } from "store/current-dashboard/types";
export const getContainerClassName = (difference, className) => (difference === 0 ? `${className} gain-loss-no-change` : className);
export const getGainLossParameters = (value, gainLoss) => {
    const icon = () => {
        if (value === 0) {
            return null;
        }
        return value > 0 ? "arrow-dropdown-up" : "arrow-dropdown";
    };
    if (gainLoss && value > gainLoss.gain) {
        return {
            classNameSuffix: "--gain",
            iconState: "gain",
            iconType: icon()
        };
    }
    if (gainLoss && value < gainLoss.loss) {
        return {
            classNameSuffix: "--loss",
            iconState: "loss",
            iconType: icon()
        };
    }
    return {
        classNameSuffix: "",
        iconState: "primary",
        iconType: icon()
    };
};
export const getLabel = (kpi, dataGranularity) => {
    switch (dataGranularity) {
        case DataGranularity.yearly:
            return kpi.gainLossIndicatorYear;
        case DataGranularity.yearOverYear:
            return kpi.gainLossIndicatorYearOverYear;
        default:
            return kpi.gainLossIndicatorQtr;
    }
};
